// extracted by mini-css-extract-plugin
export default {"modalContent":"Transfer_modalContent__1qDSl","container":"Transfer_container__PODZC","moveButtons":"Transfer_moveButtons__kdtNC"};